import React from 'react';
import PropTypes from 'prop-types';

import { ratingTypes } from '../../../../../utils/constants';
import { sportTypeIds } from '../../../../../utils/eventConstants';

import styles from '../../../../SearchPage/search.scss';

function StandingsHeaderColumns({
    sportTypeId,
    isIndexDisplayed = false,
    isRoundRobin = false,
    isAdHoc = false,
    isDoubleElimination = false,
    isFeedInBackDraw = false,
    isFirstMatchBackDraw = false,
}) {
    const isTennisSportEvent = sportTypeId === sportTypeIds.TENNIS;
    const isPickleBallSportEvent = sportTypeId === sportTypeIds.PICKLEBALL;

    const shouldDisplayPlayoffColumns = isRoundRobin || isAdHoc;

    const getRecordColumnName = () => {
        if (shouldDisplayPlayoffColumns) {
            return 'PL Record';
        }

        if (isDoubleElimination || isFeedInBackDraw || isFirstMatchBackDraw) {
            return 'MD Record';
        }

        return 'Record';
    };

    const getColumnsClassName = () => {
        if (isIndexDisplayed) {
            if (shouldDisplayPlayoffColumns) {
                return 'col-md-8';
            }

            return 'col-md-7';
        }

        if (shouldDisplayPlayoffColumns) {
            return 'col-md-9';
        }

        return 'col-md-8';
    };

    return (
        <div className={`${styles.searchHeaders} d-none d-md-flex`}>
            <div className="flex-grow">
                <div className="row">
                    {isIndexDisplayed && (
                        <div className={`col-sm-1`}>Rank</div>
                    )}
                    <div className={`col-sm-${shouldDisplayPlayoffColumns ? '3' : '4'}`}>
                        Name
                    </div>
                    <div className={getColumnsClassName()}>
                        <div className="row w-100">
                            {isTennisSportEvent && (
                                <div className={`col text-center`}>
                                    {ratingTypes.tennis}
                                </div>
                            )}
                            {isPickleBallSportEvent && (
                                <div className={`col text-center`}>
                                    {ratingTypes.pickleball}
                                </div>
                            )}
                            <div className={`col text-center`}>
                                {shouldDisplayPlayoffColumns ? 'PL ' : ''}Matches
                            </div>
                            <div className={`col text-center`}>
                                {getRecordColumnName()}
                            </div>
                            {(isDoubleElimination || isFeedInBackDraw || isFirstMatchBackDraw) && (
                                <div className={`col text-center`}>
                                    BD Record
                                </div>
                            )}
                            <div className={`col text-center`}>
                                {shouldDisplayPlayoffColumns ? 'PL ' : ''}{isPickleBallSportEvent ? 'Games' : 'Sets'}
                            </div>
                            <div className={`col text-center`}>
                                {shouldDisplayPlayoffColumns ? 'PL ' : ''}{isPickleBallSportEvent ? 'Pts record' : 'Games'}
                            </div>
                            {isRoundRobin && (
                                <>
                                    <div className={`col text-center`}>
                                        RR Matches
                                    </div>
                                    <div className={`col text-center`}>
                                        RR Record
                                    </div>
                                    <div className={`col text-center`}>
                                        RR {isPickleBallSportEvent ? 'Games' : 'Sets'}
                                    </div>
                                    <div className={`col text-center`}>
                                        RR {isPickleBallSportEvent ? 'Pts record' : 'Games'}
                                    </div>
                                </>
                            )}
                            {isAdHoc && (
                                <>
                                    <div className={`col text-center`}>
                                        Main Matches
                                    </div>
                                    <div className={`col text-center`}>
                                        Main Record
                                    </div>
                                    <div className={`col text-center`}>
                                        Main {isPickleBallSportEvent ? 'Games' : 'Sets'}
                                    </div>
                                    <div className={`col text-center`}>
                                        Main {isPickleBallSportEvent ? 'Pts record' : 'Games'}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

StandingsHeaderColumns.propTypes = {
    sportTypeId: PropTypes.number,
    isIndexDisplayed: PropTypes.bool,
    isRoundRobin: PropTypes.bool,
    isAdHoc: PropTypes.bool,
    isDoubleElimination: PropTypes.bool,
    isFeedInBackDraw: PropTypes.bool,
    isFirstMatchBackDraw: PropTypes.bool,
};

StandingsHeaderColumns.defaultProps = {
    sportTypeId: sportTypeIds.TENNIS,
    isIndexDisplayed: false,
    isRoundRobin: false,
    isAdHoc: false,
    isDoubleElimination: false,
    isFeedInBackDraw: false,
    isFirstMatchBackDraw: false,
};

export default StandingsHeaderColumns;
